import { useEstabsContext } from './EstabsContext';
import { calendarDisplayDate } from '../utils/date-time';
// FilterAppContext.tsx
import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import { useAuthContext } from './AuthContext';

type FilterAppContextType = {
    attendantId: string;
    date: Date;
    setAttendantId: (id: string) => void;
    setDate: (date: Date) => void;
};

const FilterAppContext = createContext<FilterAppContextType | undefined>(undefined);

export const FilterAppProvider = ({ children }: { children: ReactNode }) => {
    const { estabSession } = useEstabsContext();
    const [date, setDate] = useState<Date>(new Date());
    const { user } = useAuthContext();

    const [attendantId, setAttendantId] = useState<string>('');

    useEffect(() => {
        if (estabSession?._id) setDate(calendarDisplayDate(new Date(), estabSession.timezone));
    }, [estabSession?._id, estabSession?.timezone]);

    useEffect(() => {
        if (!!user?.uid) {
            setAttendantId(user?.uid);
        }
    }, [user]);

    useEffect(() => {
        if (!attendantId && !!user?.uid) {
            setAttendantId(user?.uid);
        }
    }, [attendantId]);

    return (
        <FilterAppContext.Provider
            value={{ attendantId, date, setAttendantId, setDate }}
        >
            {children}
        </FilterAppContext.Provider>
    );
};

export const useFilterApp = () => {
    const context = useContext(FilterAppContext);
    if (!context) {
        throw new Error('useFilterApp deve ser usado dentro de FilterAppProvider');
    }
    return context;
};
